import styled from 'styled-components';

export const StyledInput = styled.input<{ isPunchup?: boolean }>`
	width: 100%;
	height: 35px;
	line-height: 20px;
	padding-left: 12px;
	padding-right: 12px;
	box-sizing: border-box;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	border: ${({ isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : 'none')};
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 16px;
	border-radius: 2px;

	::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	&:focus {
		outline: 0;
		border: ${({ theme, isPunchup }) => (isPunchup ? '1px solid #fe5e25' : `0.5px solid ${theme.colors.lightGrey4}`)};
	}
`;

export const InputContainer = styled.div<{ hasError?: boolean; isPunchup?: boolean }>`
	margin-top: ${({ hasError }) => hasError && '4px'};
	width: 100%;

	${({ hasError, theme }) =>
		hasError &&
		`
		${StyledInput} {
			border: 0.5px solid ${theme.colors.red};
		}
	`}
`;

export const InputDescription = styled.div<{ isPunchup?: boolean }>`
	font-size: 12px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey5 : theme.colors.lightGrey4)};
	margin-top: 4px;
	line-height: 1.4;
`;
